import React from 'react';

import './linkText.scss';

interface Props {
  content: JSX.Element | string;
  onClick: () => void;
  style?: object;
  className?: string;
}

const LinkText: React.FC<Props> = (props: Props) => (
  <span
    className={`linktext ${props.className}`}
    style={props.style}
    onClick={props.onClick}
  >
    {props.content}
  </span>
);

export default LinkText;
